/**
 * Clean OAuth hashes after the auth provider redirects back.
 *
 * Supabase consumes the fragment immediately on load; we only strip it later to
 * avoid invalid-selector router warnings and to keep auth code out of the
 * initial client bundle.
 */
export default defineNuxtPlugin(() => {
  if (process.server) {
    return
  }

  const hasOAuthParams = (hash: string) =>
    hash.includes('access_token=') ||
    hash.includes('refresh_token=') ||
    hash.includes('expires_at=') ||
    hash.includes('provider_token=')

  const cleanupOAuthHash = () => {
    if (typeof window === 'undefined') {
      return
    }

    const hash = window.location.hash
    if (!hash || !hasOAuthParams(hash)) {
      return
    }

    try {
      const url = new URL(window.location.href)
      const cleanUrl = `${url.pathname}${url.search}`

      window.history.replaceState(window.history.state, '', cleanUrl)
      console.log('[OAuth Cleanup] Removed OAuth hash from URL')
    } catch (error) {
      console.error('[OAuth Cleanup] Error cleaning URL:', error)
    }
  }

  window.setTimeout(() => {
    cleanupOAuthHash()
    window.setTimeout(cleanupOAuthHash, 3000)
  }, 3000)
})
